import { useFeatureAvailable, useSoftDeployAccess } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function ListAppointmentsAllowed() {
	const hasReactList = useSoftDeployAccess('REACT_APPOINTMENTS_LIST');
	const hasFeature = useFeatureAvailable(Feature.ACTIVITIES_AND_APPOINTMENTS);
	return hasReactList && hasFeature;
}
